import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { submitRegistration, type RegistrationFormValues, type RegistrationResponse } from '../api/auth.api';

/**
 * Hook for handling user registration
 * Uses React Query mutation for registration submission
 * Updates auth store and redirects on success
 */
export function useRegistration() {
  const navigate = useNavigate();
  const setSession = useAuthStore((state) => state.setSession);

  return useMutation({
    mutationFn: ({ flowId, values }: { flowId: string; values: RegistrationFormValues }) =>
      submitRegistration(flowId, values),
    onSuccess: (data: RegistrationResponse) => {
      // If registration successful and we have a session, update store and redirect
      if (data.session) {
        setSession(data.session);
        navigate('/dashboard');
      }
      // If we get a flow back, it means we need more input (e.g., email verification)
      // The UI should handle this by showing the updated flow
    },
    onError: (error) => {
      // Error handling is done in the component
      console.error('Registration error:', error);
    },
  });
}
